import { Box, Typography, Checkbox } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import ImageView from "../ImageView/ImageView";
import "./ChadhavaItemList.scss";

const ChadhavaItemList = (props: any) => {
  const { name, chadhavaPic, checked, price, onSelectChange, currency } = props;
  return (
    <Box className={`productItem ${checked ? "active" : ""}`}>
      <Box className="itemTitle">
        <Typography>{name}</Typography>
      </Box>

      <Box className="imageContainer">
        <Box className="itemImg">
          {chadhavaPic && (
            <ImageView
              src={chadhavaPic}
              alt={name}
              sizes="(max-width: 768px) 75px, 75px"
            />
          )}
        </Box>

        <Checkbox
          checked={checked}
          onChange={() => onSelectChange()}
          className="customCheckbox"
          icon={<Box className="checkboxBox uncheckedBox" />}
          checkedIcon={
            <Box className="checkboxBox checkedBox">
              <CheckIcon className="tickIcon" />
            </Box>
          }
        />
      </Box>

      <Box className="price">
        <Typography>
          {currency}{ price || ""}
        </Typography>
      </Box>
    </Box>
  );
};

export default ChadhavaItemList;
